<template>
	<div v-if="item" class="mia-AttachedItem">
		<a class="mia-RemoveButton btn" @click="onCrossClick()">
			<responsive-image :from="cross" class="mia-Image mia-u-fillParentWidth" />
		</a>
		<responsive-image :from="item.Image" class="mia-Image mia-item" />
		<input id="attachedItemSelector" :value="item.Id" type="hidden" class="mia-HiddenField imageInput">
	</div>
</template>
<script lang="ts">
import { Component, Prop, Vue, toNative } from "vue-facing-decorator";
import { MiaPlaza } from "@/Reinforced.Typings";
import { useSelectedItemStore } from "@/Control/Vue/Stores/SelectedItemStore";
import ResponsiveImage from "@/Control/Vue/ResponsiveImage";

@Component({
	components: {
		ResponsiveImage,
	},
})
export class AttachedItem extends Vue {
	@Prop({ required: true, type: String }) private storeName!: string;
	@Prop({ required: true }) cross!: MiaPlaza.Navigation.JSON.Converters.ILazySizes;

	get item(): any {
		return useSelectedItemStore(this.storeName).selected;
	}

	onCrossClick(): void {
		useSelectedItemStore(this.storeName).set(null);
	}
}

export default toNative(AttachedItem);
</script>
